(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.bootstrapModal = {
        attach: function (context, settings) {
            once('modal-trigger', '[data-toggle="modal"]', context).forEach(function (trigger) {
                trigger.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const targetSelector = this.getAttribute('data-target');
                    const modalElement = document.querySelector(targetSelector);

                    if (modalElement && typeof bootstrap !== 'undefined') {
                        const modal = new bootstrap.Modal(modalElement);
                        
                        modalElement.addEventListener('shown.bs.modal', function () {
                            document.documentElement.classList.add('overflow-hidden');
                        });
                        
                        modalElement.addEventListener('hidden.bs.modal', function () {
                            document.documentElement.classList.remove('overflow-hidden');
                        });
                        
                        modal.show();
                    }

                    return false;
                }, true);
            });
        }
    };

})(Drupal, once);